module.exports = __webpack_public_path__ + "img/SplashInnovation3.ea379464.jpg";